import { defineMessages } from 'react-intl';

export const messages: {
	collapse: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	expand: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	collapse: {
		id: 'ai-mate.conversation-assistant-message-actions.action-card-wrapper.collapse',
		defaultMessage: 'Collapse',
		description:
			'Button label or action text displayed on a button or clickable element in an action card header within the AI conversation interface. Shown as clickable text on a collapse/expand control. When clicked, it collapses the action card to hide its content and show only the header. The purpose is to allow users to minimize action cards to save screen space and reduce visual clutter in the conversation view.',
	},
	expand: {
		id: 'ai-mate.conversation-assistant-message-actions.action-card-wrapper.expand',
		defaultMessage: 'Expand',
		description:
			'Button label or action text displayed on a button or clickable element in a collapsed action card header within the AI conversation interface. Shown as clickable text on a collapse/expand control. When clicked, it expands the action card to reveal its full content. The purpose is to allow users to view the complete action card details when it has been previously collapsed.',
	},
});
